<template>
    <div>
        <div class="col-xs-12 col-sm-7 col-md-8">
            <div class="row">
                <div class="col-xs-12 no-padding" v-html="title">
                </div>
            </div>

            <div class="row proddescr">
                <div v-if="product.iconFont" class="hidden-xs prod-icon" :class="product.iconFont"></div>

                <div class="proddescrtext text-uppercase">
                    <span id="productCategory" class="proddescrcat">{{ product['category'] }}</span>
                    <h1 id="productName" class="proddescrname no-margin" role="heading" aria-level="1">{{ product['name'] }}</h1>
                </div>
            </div>

            <quality-details :product-id="productId"
                             :product="product"
                             :qualityData="qualityData"
                             :initialQuality="initialValues.quality"
                             :featureFlags="featureFlags"
                             ref="qualityDetails"
                             :furtherProducts="furtherProducts"
                             :faq="faq"
                             v-on:quality-changed="changeQuality"
                             :navigation="navigation"
                             :voucher-general="voucherGeneral"
                             :checkoutParameters="checkoutParameters"
                             :default-sales-channel="defaultSalesChannel"
                             :sales-channel="salesChannel"
                             :media="media"
                             :lang="lang"
                             :trust-badges="trustBadge" >
            </quality-details>
        </div>

        <div v-if="productId" class="col-xs-12 col-sm-5 col-md-4">
            <product-configurator :product-id="productId"
                                  :product="product"
                                  :campaign="campaign"
                                  :initialValues="initialValues"
                                  :checkoutParameters="checkoutParameters"
                                  :featureFlags="featureFlags"
                                  ref="productConfigurator"
                                  :hoverText="hoverText"
                                  :disable-sepa="disableSepa"
                                  :disable-creditcard="disableCreditcard"
                                  :lang="lang"
                                  :lang-extranet="langExtranet"
                                  :new-electronic-product="newElectronicProduct"
                                  :default-sales-channel="defaultSalesChannel"
                                  :products-with-single-two-years-durations="productsWithSingleTwoYearsDurations"
                                  v-on:quality-changed="changeQuality"
                                  :haspa-product="haspaProduct"
                                  :haspa-joker-product="haspaJokerProduct"
                                  :smm-product="smmProduct"
                                  :config-duration="configDuration"
                                  :config-contract-type="configContractType"
                                  :hs-product="hsProduct"
                                  :sales-channel="salesChannel"
                                  :sales-channel-products-without-single-durations="salesChannelProductsWithoutSingleDurations"
                                  :min-subscription-durations="minSubscriptionDurations"
                                  :texts="texts"
                                  :policy-attributes="policyAttributes"
                                  :product-selector="productSelector"
                                  :prismic-qualities="qualityData.qualities"
                                  :locale="locale"
                                  :paymentLogo="paymentLogo"
                                  :product-attribute="productAttribute"
                                  :bundle-coverage="bundleCoverage"
                                  :connect-api-url="connectApiUrl"
            >
            </product-configurator>
        </div>
    </div>
</template>

<script>
    export default {
        props: [
            'productId', 'product', 'title', 'qualityData', 'initialValues', 'checkoutParameters', 'furtherProducts', 'featureFlags', 'hoverText', 'disableSepa', 'disableCreditcard',
            'lang', 'langExtranet', 'faq', 'newElectronicProduct', 'defaultSalesChannel', 'productsWithSingleTwoYearsDurations',
            'haspaProduct', 'haspaJokerProduct', 'configDuration', 'configContractType', 'navigation', 'voucherGeneral',
            'smmProduct', 'hsProduct', 'salesChannel', 'salesChannelProductsWithoutSingleDurations', 'minSubscriptionDurations', 'policyAttributes', 'productSelector', 'campaign', 'media', 'locale', 'paymentLogo',
'productAttribute', 'bundleProduct', 'bundleCoverage', 'trustBadge', 'connectApiUrl'
        ],
        name: "product-overview",
        data: function() {
            return {
                texts: {
                    insuranceSum: this.langExtranet.insuranceSum,
                    timeUnit: this.langExtranet.timeUnit,
                }
            }
        },
        methods: {
            changeQuality: function (qualityId) {
                this.$refs.qualityDetails.qualityId = qualityId;
                this.$refs.productConfigurator.qualityId = qualityId;
                this.$emit('quality-changed', qualityId)
            },
        },
    }
</script>
